import { Bar } from "react-chartjs-2";
import { IWorkoutStatisticsWeekly } from "../models/workoutStatisticsViewModel";
import { shortDate } from "../utils/statisticsFormat";
import { CHART_GRID_COLOR, CHART_TEXT_COLOR } from "../charts/registerCharts";
import styles from "../WorkoutStatistics.module.scss";

interface IFrequencyChartProps {
  weeklyFrequency: IWorkoutStatisticsWeekly[];
}

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: { legend: { display: false } },
  scales: {
    x: { grid: { display: false }, ticks: { color: CHART_TEXT_COLOR } },
    y: {
      beginAtZero: true,
      grid: { color: CHART_GRID_COLOR },
      ticks: { color: CHART_TEXT_COLOR, stepSize: 1 },
    },
  },
};

/** Workouts per week (consistency). */
export const FrequencyChart = ({ weeklyFrequency }: IFrequencyChartProps) => {
  const frequencyData = {
    labels: weeklyFrequency.map((w) => shortDate(w.weekStart)),
    datasets: [
      {
        label: "Тренировки",
        data: weeklyFrequency.map((w) => w.workoutCount),
        backgroundColor: "#6fcf97",
        borderRadius: 6,
        maxBarThickness: 38,
      },
    ],
  };

  return (
    <div className={styles.chart_card}>
      <h3 className={styles.chart_title}>Тренировки на седмица</h3>
      <div className={styles.chart_canvas}>
        <Bar data={frequencyData} options={options} />
      </div>
    </div>
  );
};
